





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Combobox extends Vue {
  @Prop() items!: any[];

  @Prop({
    required: false,
    default: '',
  })
  label!: string;

  @Prop() disabled?: boolean;

  @Prop({
    type: [String, Array],
    required: true,
  }) value!: string | string[];

  @Prop({
    required: false,
    default: '',
  })
  placeholder!: string;

  @Prop({
    required: false,
  })
  rules?: any;

  @Prop({
    required: false,
    default: false,
  }) allowNewItem!: boolean;

  @Prop({
    required: true,
  }) itemsIsObject!: boolean;

  @Prop({
    type: String,
    required: false,
    default: '',
  }) itemFilterKey!: string;

  @Prop({
    type: String,
    required: false,
    default: 'name',
  }) itemText!: string;

  @Prop({
    type: String,
    required: false,
    default: 'id',
  }) itemValue!: string;

  searchInput: string = '';

  validateChange(newValue: any[]) {
    if (!this.allowNewItem) {
      const validItems = this.getValidNewItems(newValue);
      this.$emit('input', validItems);
      return;
    }
    this.$emit('input', newValue);
    this.searchInput = '';
  }

  getValidNewItems(newValue: any[]) {
    if (this.itemsIsObject && this.itemFilterKey) {
      return this.getValidNewItemsWhenItemsIsObject(newValue);
    }
    return this.getValidNewItemsWhenItemsIsString(newValue);
  }

  getValidNewItemsWhenItemsIsObject(newValue: any[]) {
    return newValue.filter((item: any) => {
      const itemValue = item[this.itemFilterKey];
      return this.items.some((validItem: any) => validItem[this.itemFilterKey] === itemValue);
    });
  }

  getValidNewItemsWhenItemsIsString(newValue: any[]) {
    return newValue.filter((item: any) => this.items.includes(item));
  }

  customFilter(item: string, queryText: string, itemText: string) {
    return itemText.toLowerCase().includes(queryText.toLowerCase());
  }
}
